import { Component, OnInit } from '@angular/core';
import { BackgroundService } from '../shared/services/background.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
  constructor(private background: BackgroundService) {}

  async ngOnInit() {
    this.background.setValue({ tall: true, header: false });
  }
}
